import { Button } from 'antd';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';

const UpdateNotification = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    const checkUpdate = () => {
      if (window.updateNotification) { 
        window.updateNotification.onUpdate(() => setUpdateAvailable(true));
      }
    };
    checkUpdate();
  }, []);

  const handleReload = () => window.location.reload();

  if (!updateAvailable) return null;

  return (
    <div className={styles.tips}>
      有新版本可用，请
      <Button type="primary"
        onClick={handleReload}
        className={styles.tipsBtn}
      >
        刷新
      </Button>
    </div>
  );
};

export default UpdateNotification;